import React, { useEffect, useState } from "react"
import CompanySelector from "ATSComponents/Common/CompanySelector"
import axios from "axios"
import moment from "moment"
import { Calendar, momentLocalizer } from "react-big-calendar"
import "react-big-calendar/lib/css/react-big-calendar.css"
import { Modal, Table, Button } from "react-bootstrap"
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer"
function MyCalendar() {
  document.title = "ATS - My Calendar";
  const [events, setEvents] = useState([])
  const [companyId, setCompanyId] = useState(null)
  const [showTodayModal, setShowTodayModal] = useState(false)
  const [modalDayEvents, setModalDayEvents] = useState([])
  const [loading, setLoading] = useState(false)
  const [todayEvents, setTodayEvents] = useState([])
  const localizer = momentLocalizer(moment)
  const [modalTitle, setModalTitle] = useState("Interviews")
  useEffect(() => {
    if (!window.currentCalendarView) window.currentCalendarView = "month"
  }, [])
  const handleCompanyChange = company => {
    if (company?.company_id) {
      setCompanyId(company.company_id)
    }
  }
  const userInfos = JSON.parse(sessionStorage.getItem("atsuser-info") || "{}")
  const user_id = userInfos?.user_details?.user_id
  useEffect(() => {
    if (companyId) fetchEvents()
  }, [companyId])
  const fetchEvents = async () => {
    setLoading(true)
    try {
      const response = await axios.get(`api/v1/events/?user_id=${user_id}&company_id=${companyId}`)
      const grouped = {}
      response.data.results.forEach(event => {
        const data = event.calendit_response?.results?.data || []
        const first = data[0]
        if (!first) return
        const key = `${first.selected_date}T${first.selected_time}`
        if (!grouped[key]) grouped[key] = []
        grouped[key].push({
          candidate: event.candidate_ids?.[0]?.name || "-",
          // recruiter: event.contact_ids[0].name || "-",
          recruiter: Array.isArray(event.contact_ids) && event.contact_ids.length
            ? event.contact_ids.map(c => c.name).join(", ")
            : "-",
          subject: event.subject || "-",
          subtype: event.event_sub_type || "-",
          selected_date: first.selected_date,
          selected_time: first.selected_time,
          duration: event.duration || "30 Minutes",
          meeting_link: first.meeting_link || null,
        })
      })
      const apiEvents = Object.keys(grouped).map(key => {
        const group = grouped[key]
        const first = group[0]
        const [year, month, day] = first.selected_date.split("-").map(Number)
        const [h = "0", m = "0", s = "0"] = (
          first.selected_time || "00:00:00"
        ).split(":")
        const start = new Date(
          year,
          month - 1,
          Number(day),
          Number(h),
          Number(m),
          Number(s)
        )
        const rawDuration = first.duration || "30"
        let durationMinutes = parseInt(
          String(rawDuration).match(/\d+/)?.[0] || "30",
          10
        )
        if (!Number.isFinite(durationMinutes) || durationMinutes <= 0)
          durationMinutes = 30
        return {
          title: "",
          start,
          end: new Date(start.getTime() + durationMinutes * 60000),
          allDay: false,
          fullData: group,
        }
      })
      const today = moment().format("YYYY-MM-DD")
      const todaysList = apiEvents
        .flatMap(e => e.fullData)
        .filter(item => item.selected_date === today)
      setTodayEvents(todaysList)
      setEvents(apiEvents)
    } catch (err) {
      console.error("Error fetching events", err)
    } finally {
      setLoading(false)
    }
  }
  const handleSelectEvent = event => {
    if (event?.fullData) {
      setModalDayEvents(event.fullData)
      setShowTodayModal(true)
    } else {
      setModalDayEvents([event])
      setShowTodayModal(true)
    }
  }
//  const DateCellWrapper = ({ value, children }) => {
//   const cellDate = moment(value).format("YYYY-MM-DD");
//   const dayEvents = events
//     .filter(e => moment(e.start).format("YYYY-MM-DD") === cellDate)
//     .flatMap(e => e.fullData || []);

//   if (dayEvents.length === 0) {
//     return <div className="calendar-cell">{children}</div>;
//   }

//   return (
//     <div
//       className="calendar-cell"
//       style={{
//         textAlign:"center",
//         display: "flex",
//         justifyContent: "center",
//         alignItems:"center"
//       }}
//     >
//       <Button
//         size="sm"
//         variant="primary"
//         onClick={() => {
//           setModalDayEvents(dayEvents);
//           setShowTodayModal(true);
//         }}
//         style={{ marginTop: "5px" }}
//       >
//         Today&apos;s Interviews ({dayEvents.length})
//       </Button>
//     </div>
//   );
// };

// const DateCellWrapper = ({ value, children }) => {
//   const cellDate = moment(value).format("YYYY-MM-DD");
//   const todayDate = moment().format("YYYY-MM-DD");

//   const isToday = cellDate === todayDate;

//   const dayEvents = events
//     .filter(e => moment(e.start).format("YYYY-MM-DD") === cellDate)
//     .flatMap(e => e.fullData || []);

//   return (
//     <div
//       className={`calendar-cell ${isToday ? "today-highlight" : ""}`}
//       // style={{
//       //   // textAlign: "center",
//       //   display: "flex",
//       //   flexDirection: "column",
//       //   justifyContent: "center",
//       //   alignItems: "center",
//       //   height: "100%",
//       // }}
//     >
//       {children}

//       {dayEvents.length > 0 && (
//         <div className="d-flex justify-content-center mt-4 p-3">
//         <Button
//           size="sm"
//           variant="primary"
//           title="Today&apos;s Interviews"
//           onClick={() => {
//             setModalDayEvents(dayEvents);
//             setShowTodayModal(true);
//           }}
//         >
//           Today&apos;s Interviews ({dayEvents.length})
//         </Button>
//         </div>
//       )}
//     </div>
//   );
// };
const DateCellWrapper = ({ value, children }) => {
  const cellDate = moment(value).startOf("day")
  const todayDate = moment().startOf("day")

  const isToday = cellDate.isSame(todayDate, "day")
  const isPast = cellDate.isBefore(todayDate, "day")
  const isFuture = cellDate.isAfter(todayDate, "day")

  const dayEvents = events
    .filter(e => moment(e.start).isSame(cellDate, "day"))
    .flatMap(e => e.fullData || [])

  if (dayEvents.length === 0) {
    return <div className="calendar-cell">{children}</div>
  }

  let buttonText = "Interviews"

  if (isToday) buttonText = `Today's Interviews (${dayEvents.length})`
  else if (isPast) buttonText = `Previous Day Interview's (${dayEvents.length})`
  else if (isFuture) buttonText = `Upcoming Interviews (${dayEvents.length})`

  return (
    <div className={`calendar-cell ${isToday ? "today-highlight" : ""}`}>
      {children}

      <div className="d-flex justify-content-center mt-4 p-3">
        <Button
          size="sm"
          variant="primary"
          onClick={() => {
            setModalDayEvents(dayEvents)
            let title = "Interviews"
              if (isToday) title = `Today's Interviews (${dayEvents.length})`
              else if (isPast) title = `Previous Day Interviews (${dayEvents.length})`
              else if (isFuture) title = `Upcoming Interviews (${dayEvents.length})`
              
              setModalTitle(title)
            setShowTodayModal(true)
          }}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  )
}

  return (
    <div className="container-fluid p-3">
      <div className="row mb-3 mt-5 align-items-center">
        <div className="col-3">
          <h5 className="section-title">My Interviews</h5>
        </div>
        <div className="col-9 d-flex justify-content-end mt-2">
          <label className="me-2">Select Company</label>
          <div className="w-100" style={{ maxWidth: "170px" }}>
            <CompanySelector onCompanyChange={handleCompanyChange} />
          </div>
        </div>
      </div>
      {loading ? (
          <OrgTableShimmer columns={4} rows={6} titleWidth="180px" />
        ) : (
        <div className="calendar-container">
          <Calendar
            localizer={localizer}
            events={events}
            startAccessor="start"
            endAccessor="end"
            views={["month", "week", "day"]}
            onView={view => (window.currentCalendarView = view)}
            // onSelectEvent={handleSelectEvent}
            components={{ dateCellWrapper: DateCellWrapper }}
            eventPropGetter={event => {
              return {
                style: {
                  backgroundColor: "transparent",
                  border: "none",
                  boxShadow: "none",
                  color: "transparent",
                  padding: 0,
                },
              }
            }}
            // popup
            // selectable
          />
        </div>
      )}

      <Modal
        show={showTodayModal}
        onHide={() => setShowTodayModal(false)}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="d-flex justify-content-center w-100">{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Recruiter Name</th>
                <th>Candidate Name</th>
                <th>Subject</th>
                <th>Subtype</th>
                <th>Interview Date</th>
                <th>Interview Time</th>
                {/* <th>Duration</th> */}
                <th>Meeting Link</th>
              </tr>
            </thead>
            <tbody>
              {modalDayEvents.map((ev, index) => (
                <tr key={index}>
                  <td title={ev.recruiter}>{ev.recruiter}</td>
                  <td>{ev.candidate}</td>
                  <td>{ev.subject}</td>
                  <td>{ev.subtype}</td>
                 <td>
                    {new Date(ev.selected_date).toLocaleDateString("en-GB")}
                  </td>

                  <td>
                    {new Date(`1970-01-01T${ev.selected_time}`).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </td>

                  {/* <td>{ev.duration}</td> */}
                 <td>
                  {ev.meeting_link ? (
                  <a
                    href={ev.meeting_link}
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => {
                      if (moment(ev.selected_date).isBefore(moment(), "day")) {
                        e.preventDefault();   // prevent navigation
                      }
                    }}
                    style={{
                      color: moment(ev.selected_date).isBefore(moment(), "day") ? "gray" : "blue",
                      textDecoration: moment(ev.selected_date).isBefore(moment(), "day")
                        ? "line-through"
                        : "underline",
                      cursor: moment(ev.selected_date).isBefore(moment(), "day")
                        ? "not-allowed"
                        : "pointer"
                    }}
                    title={
                      moment(ev.selected_date).isBefore(moment(), "day")
                        ? "You cannot access the meeting link for past dates."
                        : "Join Meeting"
                    }
                  >
                    Join
                  </a>
                ) : (
                  "N/A"
                )}
                </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button variant="secondary" className="blueBtn" onClick={() => setShowTodayModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
export default MyCalendar
